import { useQuery } from '@tanstack/react-query';
import { marketsApi } from '../services/api/markets';

export const useContinents = () => {
  return useQuery({
    queryKey: ['continents'],
    queryFn: () => marketsApi.getContinents(),
    staleTime: 30 * 24 * 60 * 60 * 1000, // 30 days
  });
};

export const useCountries = (continentId: number | null) => {
  return useQuery({
    queryKey: ['countries', continentId],
    queryFn: () => marketsApi.getCountries(continentId!),
    enabled: continentId !== null,
    staleTime: 30 * 24 * 60 * 60 * 1000, // 30 days
  });
};

export const useMarkets = (countryId: number | null) => {
  return useQuery({
    queryKey: ['markets', countryId],
    queryFn: () => marketsApi.getMarkets(countryId!),
    enabled: countryId !== null,
    staleTime: 7 * 24 * 60 * 60 * 1000, // 7 days
  });
};

export const useMarketKPIs = (marketId: number | null, slice: string = 'All') => {
  return useQuery({
    queryKey: ['marketKPIs', marketId, slice],
    queryFn: () => marketsApi.getMarketKPIs(marketId!, slice),
    enabled: marketId !== null,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};

export const useKPIDetail = (
  marketId: number | null,
  kpiType: 'occupancy' | 'adr' | 'revpar' | 'rooms' | 'demand',
  years: number = 5,
  classification: string = 'All'
) => {
  return useQuery({
    queryKey: ['kpiDetail', marketId, kpiType, years, classification],
    queryFn: () => marketsApi.getKPIDetail(marketId!, kpiType, years, classification),
    enabled: marketId !== null,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};

export const useAirportDetail = (
  marketId: number | null,
  airportCode: string | null,
  years: number = 5
) => {
  return useQuery({
    queryKey: ['airportDetail', marketId, airportCode, years],
    queryFn: () => marketsApi.getAirportDetail(marketId!, airportCode!, years),
    enabled: marketId !== null && airportCode !== null,
    staleTime: 24 * 60 * 60 * 1000, // 24 hours
  });
};
